<!-- Sidebar -->
<div class="w3-sidebar w3-bar-block w3-animate-left sidebar-transition" id="mySidebar_email_filter" style="font-family: 'Poppins';">

  <div class="pt-4">
    <div class="row mb-3">
      <div class="col d-flex justify-content-between">
        <span class="font-weight-500 f-18 text-484b59"><i class="fa-light fa-filters mr-1"></i>Filter</span>
        <span (click)="resetFilter()"  class="pointer text-blue f-14">Reset</span>
      </div>
    </div>
    <hr style="margin: 0;">
    <div class="card bt" style="font-family: 'Poppins';">
      <div class="card-header" id="headingOne">
        <h5 class="mb-0">
          <button data-testid="auto-app-email-campaign-filter-button-1" class="btn btn-link px-0 collapsed f-14 w-100 text-left" type="button" data-bs-toggle="collapse"
            data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
            <span class="position-relative font-weight-500"> Email </span>
            <!-- <span *ngIf="emailFilter !== 'All'" class="red-dot" style="color:#CD0F0F">&bull;</span> -->
            <span class="wcAccordianUpDownArrow text-webbtree-green">
              <span class="test1"><i class="far fa-angle-up f-14 font-weight-500"></i></span>
              <span class="test2"> <i class="far fa-angle-down font-weight-500 f-14"></i></span>
            </span>
          </button>
        </h5>
      </div>

      <div id="collapseOne" class="collapse" aria-labelledby="headingOne">
        <div class="position-relative mb-3" style="font-family: Poppins;">

          <mat-radio-group aria-label="Select an option" class="d-flex flex-column filter-radio-btn" (change)="updateFilter()" [(ngModel)]="emailFilter">
            <mat-radio-button value="All">All</mat-radio-button>
            <mat-radio-button value=true>Email found</mat-radio-button>
            <mat-radio-button value=false>Email not found</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </div>
    <div class="card bt">
      <div class="card-header" id="headingTwo">
        <h5 class="mb-0">
          <button data-testid="auto-app-email-campaign-filter-button-2" class="btn btn-link px-0 collapsed f-14 w-100 text-left" type="button" data-bs-toggle="collapse"
            data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
            <span class="position-relative font-weight-500"> Status </span>
            <!-- <span *ngIf="statusFilter !== 'All'" class="red-dot" style="color:#CD0F0F">&bull;</span> -->

            <span class="wcAccordianUpDownArrow text-webbtree-green">
              <span class="test1"><i class="far fa-angle-up f-14 font-weight-500"></i></span>
              <span class="test2"> <i class="far fa-angle-down font-weight-500 f-14"></i></span>
            </span>
          </button>
        </h5>
      </div>

      <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo">
        <div class="position-relative mb-3" style="font-family: 'Poppins';">
          <mat-radio-group aria-label="Select an option" class="d-flex flex-column filter-radio-btn" [(ngModel)]="statusFilter" (change)="updateFilter()">
            <mat-radio-button value="All">All</mat-radio-button>
            <mat-radio-button value="false">Not Opened</mat-radio-button>
            <mat-radio-button value="true">Opened</mat-radio-button>
            <mat-radio-button value="completed">Completed</mat-radio-button>
            <mat-radio-button value="replied">Replied</mat-radio-button>
            <mat-radio-button value="unsubscribed">Unsubscribed</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </div>
    <div class="card bt">

      <div class="card-header" id="headingThree">
        <h5 class="mb-0">
          <button data-testid="auto-app-email-campaign-filter-button-3" class="btn btn-link px-0 collapsed f-14 w-100 text-left" type="button" data-bs-toggle="collapse"
            data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
            <span class="position-relative font-weight-500"> Steps </span>
            <!-- <span *ngIf="emailFilter !== 'All'" class="red-dot" style="color:#CD0F0F">&bull;</span> -->
            <span class="wcAccordianUpDownArrow text-webbtree-green">
              <span class="test1"><i class="far fa-angle-up f-14 font-weight-500"></i></span>
              <span class="test2"> <i class="far fa-angle-down font-weight-500 f-14"></i></span>
            </span>
          </button>
        </h5>
      </div>

      <div id="collapseThree" class="collapse" aria-labelledby="headingThree">
        <div class="position-relative mb-3 font-weight-500">
            <mat-select [(ngModel)]="stepSelection" (selectionChange)="selectedItem($event)"
             class="wc-form-control no-outline inputheight default-placeholder" placeholder="Select steps">
              <mat-option [value]="step" *ngFor="let step of stepsList">{{step}}</mat-option>
            </mat-select>

            <mat-chip-set #steps__chipList>
              <mat-chip class="mr-2 my-2 text-truncate green-chip"
                  [removable]="removable"
                  *ngFor="let cs of selectedSteps">

                  <span class="trim-chip text-truncate text-webbtree-green hoverable-element f-12 d-flex align-items-center">
                      <span class="mx-1">{{cs}}</span>
                  </span>
               <span matChipRemove  class="mr-1">
                  <i class="far fa-times f-12 green-chip" style="margin-left: 1px;
                      margin-top: 5px;" (click)="removeChip(cs, 'steps')"></i>
                </span>
              </mat-chip>
          </mat-chip-set>
        </div>
      </div>

    </div>

  </div>
</div>

<div class="w3-overlay w3-animate-opacity close-overlay-transition" (click)="filterSlider_close()"
  id="myOverlay_email_filter"></div>
